"use strict";

var LoggerInstance = require("js-logger").get("SmartyStreetsApi");

var AbstractApi = require("./AbstractApi");

var ApiHelper = require("../shared/ApiHelper");

var SmartyStreetsApi = class extends AbstractApi {
	//Call made to SO API
	getSmartyStreetsHtml(themeId) {
		if (!themeId) {
			return ApiHelper.logErrorAndReturnRejectedDeferred(LoggerInstance, `ThemeId was not specified: ${themeId}.`);
		}

		return this.get({
			url: "/api/smartystreets",
			queryString: {
				themeId
			}
		});
	}

	//Call made to SmartyStreets.com
	autoCompleteAddress(options) {
		options = options || {};

		if (!options.singleLineAddress) {
			return ApiHelper.logErrorAndReturnRejectedDeferred(LoggerInstance, `Single Line Address Not Provided: ${options.singleLineAddress}.`);
		}
		var apiKeyWizard = window.AccountStore.get("wizardSmartyStreetsApiKey");
		if (!apiKeyWizard || !apiKeyWizard.apiKey) {
			return ApiHelper.logErrorAndReturnRejectedDeferred(LoggerInstance, "SmartyStreets Api Key is not provided.");
		}

		return this.get({
			url: "https://us-autocomplete-pro.api.smartystreets.com/lookup",
			queryString: ApiHelper.deleteUndefinedValues({
				"auth-id": apiKeyWizard.apiKey,
				"search": options.singleLineAddress,
				"max_results": options.suggestions || 10,
				"geolocate_precision": (options.geolocate === true) ? options.geolocatePrecision || "city" : "none",
				"selected": options.selected
			})
		});
	}

	//Call made to SmartyStreets.com
	verifyUsAddress(options) {
		options = options || {};

		if (!options.street) {
			//A street must be provided, at least
			return ApiHelper.logErrorAndReturnRejectedDeferred(LoggerInstance, `Street Not Provided: ${options.street}.`);
		}
		var apiKeyWizard = window.AccountStore.get("wizardSmartyStreetsApiKey");
		if (!apiKeyWizard || !apiKeyWizard.apiKey) {
			return ApiHelper.logErrorAndReturnRejectedDeferred(LoggerInstance, "SmartyStreets Api Key is not provided.");
		}

		return this.get({
			url: "https://us-street.api.smartystreets.com/street-address",
			queryString: ApiHelper.deleteUndefinedValues({
				"auth-id": apiKeyWizard.apiKey,
				"input_id": options.inputId || undefined,
				"street": options.street || undefined,
				"city": options.city || undefined,
				"state": options.state || undefined,
				"zipcode": options.zipcode || undefined,
				"street2": options.street2 || undefined, //something like "Leave it on the front porch"
				"secondary": options.secondary || undefined, // Apt 52 or 52 not Apt52
				"candidates": options.candidates || 3,
				"match": options.match || "strict" // strict, range, invalid
			})
		});
	}
};

module.exports = new SmartyStreetsApi();
